export default __webpack_public_path__ + "static/media/1197.56578b50.png";